import styled from 'styled-components'

export const SearchLocationDistance = styled.div`
  margin-right: 20px;

  > span {
    color: ${ (props) => props.theme.colors['aok-gruen'] };
  }

  svg {
    margin-right: 10px;
    stroke: black;
    stroke-width: 0.4px;
    path {
      fill: ${ (props) => props.theme.colors['icon-grau1'] };
    }
  }

  &.no-padding {
    margin-right: 0;
  }
`
